/* ============================================================
   rematech · Product Card · COMPORTAMIENTO
   DS v2.0 · pareja de snippets/rmt-pcard.liquid
   ============================================================

   POR QUÉ DELEGACIÓN Y NO UN LISTENER POR TARJETA

   La alternativa obvia es querySelectorAll('.pcard') y enganchar un
   listener a cada una. No sirve aquí, por dos razones:

   1. Las tarjetas llegan DESPUÉS. Filtros AJAX de colección,
      paginación infinita y la Section Rendering API inyectan HTML
      nuevo cuando el script ya corrió. Esas tarjetas nacerían muertas.

   2. Con 3 secciones de 8 productos son 24 listeners por evento.
      Aquí son 2 en total, siempre.

   Se engancha en document y se resuelve el destino con closest().

   El número de WhatsApp NO vive aquí: viaja en data-wa de cada botón,
   puesto por el snippet. Así el asset queda estático y cacheable, y
   cada sección puede tener su propio número.

   EVENTOS QUE EMITE (escúchalos en document para analítica)
     rmt:product_card_click  { handle, position, productId }
     rmt:waitlist_capture    { model_or_query, kind, channel, source }
   ============================================================ */

(function () {
  'use strict';

  /* Guarda de doble inicialización.
     Si el archivo termina incluido dos veces (una sección vieja que
     todavía trae su etiqueta, por ejemplo), sin esto cada click
     dispararía el evento de analítica dos veces y las métricas
     saldrían infladas al doble. */
  if (window.__rmtPcardReady) return;
  window.__rmtPcardReady = true;

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
  }

  function closestFrom(target, selector) {
    if (!target || !target.closest) return null;
    return target.closest(selector);
  }

  /* ── Click en la tarjeta · sólo analítica ──────────────────────
     No hay preventDefault: la tarjeta es un <a> real y debe navegar
     normal, incluyendo cmd+click, click de rueda y "abrir en pestaña
     nueva". Interceptar la navegación rompería todo eso. */
  document.addEventListener('click', function (e) {
    var card = closestFrom(e.target, '[data-pr-card]');
    if (!card) return;

    /* Si el click fue en un botón dentro de la tarjeta, ese botón ya
       tiene su propio manejo. No cuenta como click de tarjeta. */
    if (closestFrom(e.target, 'button')) return;

    emit('rmt:product_card_click', {
      handle:    card.getAttribute('data-pr-card'),
      position:  parseInt(card.getAttribute('data-position'), 10) || 0,
      productId: card.getAttribute('data-product-id')
    });
  });

  /* ── Botón "Avísame" · producto agotado ────────────────────────
     preventDefault + stopPropagation porque el botón vive DENTRO del
     <a> de la tarjeta: sin eso el navegador seguiría el href y el
     usuario terminaría en la ficha de producto en vez de en WhatsApp. */
  document.addEventListener('click', function (e) {
    var btn = closestFrom(e.target, '[data-notify-btn]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var title = btn.getAttribute('data-product-title') || '';
    var wa    = btn.getAttribute('data-wa') || '';
    if (!wa) return;

    var msg = 'Hola, busqué "' + title + '" en rematech.mx y está agotado. ¿Me avisas cuando llegue?';

    emit('rmt:waitlist_capture', {
      model_or_query: title,
      kind:           'B',
      channel:        'whatsapp',
      source:         'pcard'
    });

    window.open(
      'https://wa.me/' + wa + '?text=' + encodeURIComponent(msg),
      '_blank',
      'noopener,noreferrer'
    );
  });


  /* ══════════════════════════════════════════════════════════════
     SOMBRAS LATERALES DEL CARRIL
     ══════════════════════════════════════════════════════════════
     Enciende la sombra de cada lado sólo cuando hay contenido oculto
     por ahí. Sin esto habría que elegir entre dos males: dejarlas
     siempre prendidas —y ensuciar la primera tarjeta al inicio y la
     última al final— o quitarlas.

     Vive en este archivo y no en la sección porque la sección puede
     repetirse en una página: cada copia traería su propio script y
     sus propios listeners. Aquí es uno solo, y con delegación agarra
     también los carriles que lleguen después (filtros AJAX,
     paginación, Section Rendering API).

     El evento scroll NO burbujea, por eso el listener va en fase de
     captura: es la única forma de oírlo desde document.
  ══════════════════════════════════════════════════════════════ */
  function updateRail(rail) {
    var track = rail.firstElementChild;
    if (!track) return;

    /* 2px de tolerancia. Los navegadores devuelven decimales en
       pantallas con densidad fraccionaria (zoom del sistema, 1.5x de
       Android), así que scrollLeft casi nunca llega al máximo exacto
       y la sombra derecha se quedaría prendida para siempre. */
    var max = track.scrollWidth - track.clientWidth;
    rail.classList.toggle('can-left', track.scrollLeft > 2);
    rail.classList.toggle('can-right', track.scrollLeft < max - 2);
  }

  function refreshAllRails() {
    var rails = document.querySelectorAll('[data-rmt-rail]');
    for (var i = 0; i < rails.length; i++) updateRail(rails[i]);
  }

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.parentElement) return;
    if (t.parentElement.hasAttribute && t.parentElement.hasAttribute('data-rmt-rail')) {
      updateRail(t.parentElement);
    }
  }, true);

  /* Tres momentos, porque el ancho del carril cambia en cada uno:
     al parsear el HTML, cuando llegan las fotos y las fuentes, y
     cuando gira el teléfono o se redimensiona la ventana. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAllRails);
  } else {
    refreshAllRails();
  }
  window.addEventListener('load', refreshAllRails);
  window.addEventListener('resize', refreshAllRails);

  /* Carriles inyectados después de la carga. */
  if (window.MutationObserver) {
    var railTimer;
    new MutationObserver(function () {
      clearTimeout(railTimer);
      railTimer = setTimeout(refreshAllRails, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

})();